/* @flow */

import { compose } from 'ramda';
import { connect } from 'react-redux';

import HelpButtonDumb from './HelpButtonDumb';
import { trackGAEvent } from 'src/shared/core/service/tracking/gaService';

const mapStateToProps = (): Object => ({
  handleClick() {
    trackGAEvent('Help', 'Click help', 'From floating button');
  },
});

export default compose(connect(mapStateToProps))(HelpButtonDumb);
